// extracted by mini-css-extract-plugin
export default {"hero":"hero___rd2el","cta_btn":"cta_btn___aGzyk","support":"support___NmDzE"};